// JQVMap - JQVMap is a jQuery plugin that renders Interactive, Clickable Vector Maps: https://github.com/10bestdesign/jqvmap/

require('jqvmap/dist/jquery.vmap.js');
require('jqvmap/dist/maps/jquery.vmap.world.js');
require('jqvmap/dist/maps/jquery.vmap.russia.js');
require('jqvmap/dist/maps/jquery.vmap.usa.js');
require('jqvmap/dist/maps/jquery.vmap.germany.js');
require('jqvmap/dist/maps/jquery.vmap.europe.js');

require('./jqvmap.scss');
